import React, {MouseEventHandler, ReactNode, useCallback, useMemo} from 'react';
import {Typography} from 'components/Typography';
import {Button} from 'components/Button';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {actionSetPortalHidden} from 'modules/portal/slice';
import {MODALS} from 'modules/modals/constants';
import {selectIsLocationsListLoading} from 'modules/locations/selectors';
import {CityName} from 'modules/locations/components/CityName';
import {applyCity} from 'modules/locations/thunks';
import style from './style.module.scss';
import classNames from 'classnames';
import Icon from 'components/Icon';

interface IProps {
    className?: string;
    chooseAnotherCity?: () => void;
    containerClassName?: string;
}

export const CityClarificationPopup = React.memo<IProps>(function CityClarificationPopup({
    chooseAnotherCity,
    containerClassName,
}) {
    const dispatch = useAppDispatch();

    const isLocationListLoading = useAppSelector(selectIsLocationsListLoading);

    const handleApplyCityClick = useCallback<MouseEventHandler<HTMLButtonElement>>(() => {
        dispatch(applyCity);
        dispatch(actionSetPortalHidden(MODALS.CITY_CLARIFICATION.name));
    }, [dispatch]);

    const handleAnotherCityClick = useCallback<MouseEventHandler<HTMLButtonElement>>(() => {
        dispatch(actionSetPortalHidden(MODALS.CITY_CLARIFICATION.name));

        if (chooseAnotherCity) {
            chooseAnotherCity();
        }
    }, [chooseAnotherCity, dispatch]);

    const renderContent = useMemo<ReactNode>(() => {
        return (
            <>
                <div className={style.actions}>
                    <Button
                        disabled={isLocationListLoading}
                        onClick={handleApplyCityClick}
                        size={'medium'}
                        theme={'primary'}
                    >
                        Да, все верно
                    </Button>
                    <Button
                        disabled={isLocationListLoading}
                        onClick={handleAnotherCityClick}
                        size={'medium'}
                        theme={'secondary'}
                    >
                        Выбрать <span className={style.textHideSm}>другой</span>
                    </Button>
                </div>
            </>
        );
    }, [handleAnotherCityClick, handleApplyCityClick, isLocationListLoading]);

    return (
        <>
            <div className={classNames(style.container, 'clarification-popup', containerClassName)}>
                <Typography color={'gray100'} element={'div'} variant={'ch-title-20-b'}>
                    Ваш город <br /> <CityName />?
                </Typography>
                <button className={style.closerIcon} onClick={handleApplyCityClick}>
                    <Icon icon={'close'} />
                </button>
                {renderContent}
            </div>
        </>
    );
});
